import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
	formControl: {
		width: '100%',
	},
	select: {
		maxHeight: '40rem',
	},
});
